/**
 * VIP 活动临时开关。
 *
 * 活动重新上线时，只需打开对应开关，并恢复 shareMoments 路由组件。
 */
export const VIP_ACTIVITY_SWITCHES = {
  shareMoments: false,
  groupVipPurchase: false,
} as const;
